"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FelaTextInput = exports.FelaRuleTextInput = exports.ruleKeysFelaTextInput = exports.ETextInputType = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const FelaCache_1 = require("../../fela/FelaCache");
const VibescoutFrontendStyleConfig_1 = require("../config/VibescoutFrontendStyleConfig");
const FelaText_1 = require("./FelaText");
var ETextInputType;
(function (ETextInputType) {
    ETextInputType["INPUT"] = "INPUT";
    ETextInputType["NUMBER"] = "NUMBER";
    ETextInputType["TEXT_AREA"] = "TEXT_AREA";
})(ETextInputType || (exports.ETextInputType = ETextInputType = {}));
exports.ruleKeysFelaTextInput = [
    "fontSize",
    "size",
    "fullWidth",
    "rounded",
    "minHeight",
    "typography",
    "weight",
    "transform",
    "padding",
    "disabled",
];
const FelaRuleTextInput = ({ theme, fontSize, size, fullWidth = false, rounded = false, minHeight, typography = VibescoutFrontendStyleConfig_1.ETextTypographyType.sansSerif, weight, transform, padding = "0.5em", disabled, }) => {
    const shadowColor = `rgba(${theme.styles.Themes[theme.currentId].shadow.base[0]}, ${theme.styles.Themes[theme.currentId].shadow.intensity + 0.15})`;
    const fontWeight = FelaText_1.weightToTextWeightType[weight ?? VibescoutFrontendStyleConfig_1.ETextWeightType.regular];
    /*
        theme.dark ? theme.styles.RgbColors.darkBack.shadow : theme.styles.RgbColors.lightBack.shadow
      */
    return {
        background: !disabled ? "white" : "rgba(150, 150, 150, 0.2)",
        borderRadius: rounded ? "10em" : "0.2em",
        boxShadow: `inset 0 0.1em 0.2em 0.1em rgba(${theme.styles.Colors.lightBack.shadow[0]}, ${theme.dark ? 0.8 : 0.3})`,
        // border: "none",
        boxSizing: "border-box",
        border: `1px solid ${disabled ? "rgba(150, 150, 150, 0.4)" : shadowColor}`,
        width: fullWidth ? "100%" : "auto",
        fontFamily: theme.styles.Font.family[typography],
        fontWeight: typography === VibescoutFrontendStyleConfig_1.ETextTypographyType.inherit
            ? "inherit"
            : theme.styles.Font.weights[typography][fontWeight],
        color: disabled
            ? theme.styles.Themes[theme.currentId].RgbColors.fore.regular
            : theme.styles.Themes[theme.currentId].RgbColors.fore.extra,
        fontSize: fontSize
            ? fontSize
            : size
                ? theme.styles.Font.sizes[size]
                : theme.styles.Font.sizes[VibescoutFrontendStyleConfig_1.ETextSize.content],
        minHeight,
        padding,
        textTransform: transform,
        "::placeholder": {
            color: theme.styles.RgbColors.lightFore.lig,
        },
        ":focus": {
            color: theme.styles.RgbColors.lightFore.dar,
        },
    };
};
exports.FelaRuleTextInput = FelaRuleTextInput;
const FelaTextInput = ({ value, onChange, onFocus, onBlur, onClick, type = ETextInputType.INPUT, placeHolder, cssExtra = [], style = {}, rootProps = {}, onChangeText, onChangeTextDelayed, onPressEnter, inputRef, trackTextWidth = false, trackMinWidth = 120, trackPadding = 25, delay = 200, initialValue, inputType, id, ...props }) => {
    const { inlineCss, cachedClass } = (0, FelaCache_1.useFelaCache)();
    const textChangeTimeout = (0, react_1.useRef)(null);
    const [internalText, setInternalText] = (0, react_1.useState)(initialValue ?? "");
    function textChange(useText) {
        if (value == null) {
            setInternalText(useText);
        }
        if (onChangeText) {
            onChangeText(useText);
        }
        if (onChangeTextDelayed) {
            clearTimeout(textChangeTimeout.current);
            textChangeTimeout.current = setTimeout(() => {
                onChangeTextDelayed(useText);
            }, delay);
        }
    }
    let onChangeFunc;
    if (onChange) {
        onChangeFunc = onChange;
    }
    else {
        onChangeFunc = (event) => textChange(event.target.value);
    }
    let onKeyDown;
    if (onPressEnter) {
        onKeyDown = (e) => {
            if (e.key === "Enter") {
                onPressEnter();
            }
        };
    }
    // let textWidth: undefined | number = undefined;
    let measureText = (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    if (type !== ETextInputType.TEXT_AREA && trackTextWidth) {
        const measureTextRef = (0, react_1.useRef)();
        if (measureTextRef.current) {
            measureTextRef.current.textContent = value || "";
            // textWidth = measureTextRef.current.clientWidth;
            style.width = `${Math.max(measureTextRef.current.clientWidth + trackPadding, trackMinWidth)}px`;
        }
        else {
            style.width = `calc(${(value?.length ?? 1) * 0.5}em + ${trackMinWidth}px)`;
        }
        measureText = ((0, jsx_runtime_1.jsx)(FelaText_1.FelaText, { style: { height: "1px", visibility: "hidden", position: "absolute" }, size: props.size, rootProps: {
                ref: (ref) => {
                    measureTextRef.current = ref ?? undefined;
                },
            }, children: value }));
    }
    const { disabled = false } = props;
    const { className, ...restRootProps } = rootProps;
    const finalClassName = `${className ?? ""} ${cachedClass(exports.FelaRuleTextInput, props, exports.ruleKeysFelaTextInput)} ${inlineCss(cssExtra)}`;
    if (type === ETextInputType.INPUT) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [measureText, (0, jsx_runtime_1.jsx)("input", { type: inputType ?? "text", ref: inputRef, disabled: disabled, onClick: onClick, onFocus: onFocus, onBlur: onBlur, style: style, placeholder: placeHolder, value: value ?? internalText, onChange: onChangeFunc, onKeyDown: onKeyDown, className: finalClassName, id: id, name: id, ...restRootProps })] }));
    }
    else if (type === ETextInputType.NUMBER) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [measureText, (0, jsx_runtime_1.jsx)("input", { ref: inputRef, disabled: disabled, onClick: onClick, onFocus: onFocus, onBlur: onBlur, style: style, placeholder: placeHolder, value: value ?? internalText, type: "number", onKeyDown: onKeyDown, onChange: onChangeFunc, className: finalClassName, id: id, name: id, ...restRootProps })] }));
    }
    return ((0, jsx_runtime_1.jsx)("textarea", { ref: inputRef, disabled: disabled, onClick: onClick, onFocus: onFocus, onBlur: onBlur, style: style, placeholder: placeHolder, onChange: onChangeFunc, onKeyDown: onKeyDown, value: value ?? internalText, className: finalClassName, id: id, name: id, ...restRootProps }));
};
exports.FelaTextInput = FelaTextInput;
